import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { catchError, of } from 'rxjs';

import { CustomTestDefinitionService } from '../services/custom-test-definition.service';
import { CustomTestDefinition } from '../models/custom-test-definition.model';

@Component({
  selector: 'cvx-test-definitions-list',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule],
  templateUrl: './test-definitions-list.component.html',
  styleUrl: './test-definitions-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestDefinitionsListComponent {
  private readonly service = inject(CustomTestDefinitionService);
  private readonly router = inject(Router);

  protected readonly definitions = toSignal(
    this.service.getAll().pipe(catchError(() => of([] as CustomTestDefinition[]))),
    { initialValue: [] as CustomTestDefinition[] }
  );

  protected readonly deleteError = signal<string | null>(null);

  protected create(): void {
    this.router.navigate(['/tools/custom-test-definitions/new']);
  }

  protected edit(id: string): void {
    this.router.navigate(['/tools/custom-test-definitions', id, 'edit']);
  }

  protected delete(id: string): void {
    if (!confirm('Delete this test definition?')) return;

    this.service.delete(id).subscribe({
      next: () => window.location.reload(),
      error: () => this.deleteError.set('Failed to delete. Please try again.'),
    });
  }
}
